"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Typography_1 = require("@material-ui/core/Typography");
const QuickDrawGameCardStyle_1 = require("../../jss/QuickDrawGameCardStyle");
const WinningNumbers = ({ visible, winningNumbers, multiplierIndex, hasBullsEye, bullsEyeIndex, extraDataConfig }) => {
    const theme = (0, core_1.useTheme)();
    const classes = (0, QuickDrawGameCardStyle_1.default)();
    if (!visible || !winningNumbers || winningNumbers.length < 1) {
        return null;
    }
    let results = winningNumbers
        .map(item => item.data)
        .filter((_value, index) => multiplierIndex !== undefined && index !== multiplierIndex);
    if (hasBullsEye && !!bullsEyeIndex) {
        results = results.filter((_value, index) => index !== bullsEyeIndex);
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.winningNumberContainer }, { children: results.map((item, index) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: getClass(item), style: {
                backgroundColor: 'initial',
                borderColor: '#212121'
            } }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ style: {
                    color: 'initial',
                    fontSize: theme.breakpoints.down('md') ? '15px' : '20px'
                } }, { children: item &&
                    (extraDataConfig === null || extraDataConfig === void 0 ? void 0 : extraDataConfig.zeroPadding) &&
                    !isNaN(parseInt(item, 10)) &&
                    parseInt(item, 10) < 10
                    ? '0' + parseInt(item, 10)
                    : item && !isNaN(parseInt(item, 10))
                        ? parseInt(item, 10)
                        : item
                            ? item
                            : '' })) }), index))) })));
    function getClass(item) {
        if (isNaN(parseInt(item, 10))) {
            return classes.textWinningNumber;
        }
        return (extraDataConfig === null || extraDataConfig === void 0 ? void 0 : extraDataConfig.showSquare) ? classes.squareWinningNumber : classes.winningNumber;
    }
};
exports.default = WinningNumbers;
//# sourceMappingURL=WinningNumbers.js.map